const cmpStockExchangeList = {
    component: null,
    init: function (element) {
        const _ = this
        _.component = element

        const cardItem = _.component.querySelectorAll(".cmp-stockexchange-cards-item")
        cardItem.forEach((el) =>
            el.addEventListener("click", this.AnnocementPopup))

        const loadmorebtn = _.component.querySelector('.cmp-perspectives-list__cta .btn-load-more')
        loadmorebtn.addEventListener("click", function (e) {
            let pageId = e.target.getAttribute("data-page")
            //console.log(pageId)
            let apiURL = '/api/StockExchange/GetAnnouncements?lang=' + document.documentElement.lang + '&pageId=' + ++pageId
            const res =
                window.fetch(apiURL)
                    .then(function (response) {
                        // The response is a Response instance.
                        return response.json();
                    }).then(function (data) {
                        // `data` is the parsed version of the JSON returned from the above endpoint.
                        //console.log(data.data)
                        const newDiv = document.createElement('list')
                        let className = 'added-items-' + pageId
                        newDiv.classList.add(
                            "added-items", 
                            className
                        )

                        newDiv.innerHTML = _.StockExchangeCardTemplate(data.data)
                        let cardContainer = document.querySelector(".cmp-stockexchange-cards__main .container .row")
                        cardContainer.appendChild(newDiv)
                        const cardItemList = _.component.querySelectorAll("." + className + " .cmp-stockexchange-cards-item")
                        //console.log(cardItemList);
                        cardItemList.forEach((el) =>
                            el.addEventListener("click", function (eve){
                                _.AnnocementPopup(eve)
                            }))
                        e.target.setAttribute("data-page", pageId)
                    })
        })
    },
    AnnocementPopup: function (event) {
        if (document.querySelector(".cmp-stockexchange-modal .modal").classList.contains('micromodal-slide')) {
            //console.log(event)
            let announcementId = undefined
            let ele = event.target
            do {
                if (ele.getAttribute("data-annId") != null) {
                    announcementId = ele.getAttribute("data-annId")
                    //console.log(ele)
                }
                ele = ele.parentNode
            } while (announcementId == undefined)
            let apiURL = '/api/StockExchange/GetAnnouncementBody'
            const url = apiURL + '?announcementId=' + announcementId
            const res =
                window.fetch(url)
                    .then(function (response) {
                        // The response is a Response instance.
                        return response.json();
                    }).then(function (data) {
                        // `data` is the parsed version of the JSON returned from the above endpoint.
                        //console.log(data)
                        document.querySelector("#stockExchangePopupModal-content").innerHTML = data
                        document.querySelector(".cmp-stockexchange-modal .modal").classList.remove('micromodal-slide')
                    })
        }
    },
    StockExchangeCardTemplate: function (cardList) {
        let cardItemList = ''
        for (let index = 0; index < cardList.length; index++) {
            cardItemList = cardItemList + '<div class="cmp-stockexchange-cards-item col-sm-4" data-toggle="modal" data-target="#exampleModal" data-annid="' + cardList[index].investegate_id + '"> <div class="cmp-stockexchange-cards-item__main col-12"> <div class="cmp-stockexchange-cards-item_outline col-box"> <div class="cmp-stockexchange-cards-item__box"> <p class="cmp-stockexchange-cards-item__main_outline_timestamp">' + cardList[index].ModifiedTimeStamp + '</p>	<h4 class="cmp-stockexchange-cards-item__main_outline__title">' + cardList[index].headline + '</h4> </div> </div>	</div> </div>'
        }
        return cardItemList
    }
}

export default cmpStockExchangeList